"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _reactTransitionGroup = require("react-transition-group");

var _classnames = _interopRequireDefault(require("classnames"));

var _Tag = _interopRequireDefault(require("../../Tag"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Header = require("./Header.style");

var _Option = require("../Option/Option");

require("./styles.css");

var MultipleHeader = function MultipleHeader(_ref) {
  var label = _ref.label,
      selectedOptions = _ref.selectedOptions,
      search = _ref.search,
      expanded = _ref.expanded,
      searchValue = _ref.searchValue,
      handleHeaderClick = _ref.handleHeaderClick,
      handleTagClick = _ref.handleTagClick,
      handleInputChange = _ref.handleInputChange,
      showSearchIcon = _ref.showSearchIcon,
      theme = _ref.theme,
      minWidth = _ref.minWidth,
      inputClassName = _ref.inputClassName,
      autoFocus = _ref.autoFocus,
      draggable = _ref.draggable,
      showSelectedOnBottom = _ref.showSelectedOnBottom,
      onDrop = _ref.onDrop;

  var renderTag = function renderTag(tag, index) {
    return _react.default.createElement(_Tag.default, {
      draggable: draggable,
      onDrop: onDrop,
      tagIndex: index,
      canClose: true,
      onCloseClick: function onCloseClick() {
        return handleTagClick(tag);
      }
    }, tag.label);
  };

  return _react.default.createElement(_Header.StyledMultipleHeader, {
    minWidth: minWidth,
    multiple: true,
    onClick: handleHeaderClick,
    tabIndex: 0,
    expanded: expanded,
    role: "button"
  }, search && showSearchIcon && _react.default.createElement(_Icon.default, {
    type: "search"
  }), !draggable && !showSelectedOnBottom && _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
    className: 'tag-list' + (draggable ? ' draggable' : '')
  }, selectedOptions.map(function (o, index) {
    return _react.default.createElement(_reactTransitionGroup.CSSTransition, {
      key: o.value,
      timeout: 200,
      classNames: "fade"
    }, renderTag(o, index));
  })), search ? _react.default.createElement("input", {
    className: (0, _classnames.default)('SelectHeader__input', (0, _Header.multipleInput)(theme), inputClassName),
    value: searchValue,
    placeholder: selectedOptions.length < 1 ? label : '',
    onChange: handleInputChange,
    style: {
      width: "".concat(searchValue.length * 11, "px")
    },
    autoFocus: autoFocus
  }) : selectedOptions.length < 1 ? label : null, !search && _react.default.createElement(_Icon.default, {
    type: "angle-down",
    rotate: expanded ? 180 : 0,
    style: {
      width: '14px',
      height: '14px',
      marginRight: '8px'
    }
  }));
};

MultipleHeader.propTypes = {
  selectedOptions: _propTypes.default.arrayOf(_propTypes.default.shape(_Option.optionPropType)).isRequired,
  search: _propTypes.default.bool.isRequired,
  searchValue: _propTypes.default.string.isRequired,
  handleHeaderClick: _propTypes.default.func.isRequired,
  handleTagClick: _propTypes.default.func.isRequired,
  handleInputChange: _propTypes.default.func.isRequired,
  showSearchIcon: _propTypes.default.bool.isRequired,
  autoFocus: _propTypes.default.bool.isRequired
};

var _default = (0, _emotionTheming.withTheme)(MultipleHeader);

exports.default = _default;